import { createSlice } from '@reduxjs/toolkit'
import { CartItemTypes } from '../../Cart/cartSlice'

const purchaseHistory = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: null,
    errorMessage: null,
    history: [],
}

const purchaseHistorySlice = createSlice({
    name: 'account/purchase',
    initialState,
    reducers: {
        purchaseHistoryRequest: state => {
            state.status = purchaseHistory.LOADING
        },
        purchaseHistoryRequestSuccess: (state, action) => {
            state.status = purchaseHistory.SUCCESS
            state.history = action.payload.map(
                ({
                    reference,
                    purchaseTime,
                    totalAmount,
                    loyaltyPoint,
                    items,
                }) => ({
                    reference,
                    date: purchaseTime,
                    price: totalAmount + loyaltyPoint,
                    amountPaid: totalAmount,
                    loyaltyPoints: loyaltyPoint,
                    items: transformItems(items),
                })
            )
        },
        purchaseHistoryRequestError: (state, action) => {
            state.status = purchaseHistory.FAILURE
            state.errorMessage = action.payload
        },
        resetState: state => initialState,
    },
})

const transformItems = items => {
    const classes = {
        //id: quantity
    }

    const classDetails = {
        //id: details
    }

    const itemsWithoutClasses = items
        .map(item => {
            if (item.orderType === CartItemTypes.Class) {
                classes[item.orderTypeId] = classes[item.orderTypeId] + 1 || 1
                classDetails[item.orderTypeId] = item
                return null
            } else {
                return {
                    description: item.data.title,
                    amount: item.amount,
                    quantity: 1,
                }
            }
        })
        .filter(item => item)

    const classItems = Object.entries(classes).map(([key, value]) => ({
        quantity: value,
        description: classDetails[key]?.data.title,
        amount: classDetails[key].amount,
        ...classDetails[key],
    }))

    return [...itemsWithoutClasses, ...classItems]
}

const {
    purchaseHistoryRequest,
    purchaseHistoryRequestSuccess,
    purchaseHistoryRequestError,
    resetState,
} = purchaseHistorySlice.actions

export const purchaseHistoryActions = {
    purchaseHistoryRequest,
    purchaseHistoryRequestSuccess,
    purchaseHistoryRequestError,
    resetState,
}

export const purchaseHistorySelectors = {
    isFetching: state =>
        state.accountPurchaseHistory.status === purchaseHistory.LOADING,
    hasError: state =>
        state.accountPurchaseHistory.status === purchaseHistory.FAILURE,
    errorMessage: state => state.accountPurchaseHistory.errorMessage,
    history: state => state.accountPurchaseHistory.history,
}

export default purchaseHistorySlice.reducer
